<template>
  <div class="modal-overlay">
    <div class="modal-background" @click="$emit('closeModal')" />
    <div class="modal">
      <graph :title="workflowLabel(title)" :has-data="true" :is-in-modal="true" @closeModal="$emit('closeModal')">
        <pie-chart :data="workflowUi(data)" :options="workflowUi({ displayLegend: true })" />
      </graph>
    </div>
  </div>
</template>

<script>
import WorkflowDisplay from '@/admin-i18n/workflows-all-display'
import Graph from '@/components/shared/graphs/graph.vue'
import PieChart from '@/components/shared/graphs/pie-chart.vue'

export default {
  mixins: [WorkflowDisplay],
  name: 'sold-tickets-modal',
  components: { PieChart, Graph },
  props: {
    title: String,
    data: Object,
  },
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}
.modal-background {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #00000050;
}
.modal {
  text-align: left;
  background-color: white;
  position: relative;
  padding: 2rem;
  border-radius: 20px;
  overflow-y: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.modal::-webkit-scrollbar {
  display: none;
}
@media screen and (max-width: 700px) {
  .modal {
    width: 100%;
    max-width: 100%;
    height: 100%;
    border-radius: 0;
  }
}
</style>
